import { injectable, provided } from "inversify-sugar";
import * as IUserRepository from "../business/IUserRepository";
import { VehicleTypeBasedInterface } from "user/business/User";

@injectable()
export default class UserUseCase {
  @provided(IUserRepository.IUserRepositoryToken)
  private userRepository!: IUserRepository.IUserRepository;

  public login(value: any) {
    return this.userRepository.login(value);
  }

  public reverseGeoCode(value: any) {
    return this.userRepository.reverseGeoCode(value);
  }

  public setPassword(value: any) {
    return this.userRepository.setPassword(value);
  }

  public setAuthUserPassword(value: any) {
    return this.userRepository.setAuthUserPassword(value);
  }

  public updateAuthMethod(value: any) {
    return this.userRepository.updateAuthMethod(value);
  }

  public updateIsFirstLogin(value: any) {
    return this.userRepository.setIsFirstLogin(value);
  }

  public acceptTerms() {
    return this.userRepository.acceptTerms();
  }
  public acceptTermsWithoutToken(values: any) {
    return this.userRepository.acceptTermsWithoutToken(values);
  }
  public signup(value: any) {
    return this.userRepository.signup(value);
  }

  public vehicleOwnerSignup(value: any) {
    return this.userRepository.vehicleOwnerSignup(value);
  }

  public createPlatformAdmin(value: any) {
    return this.userRepository.createPlatformAdmin(value);
  }

  public getAllPlatformAdmin(page: number, input: string, filter: string) {
    return this.userRepository.getAllPlatformAdmin(page, input, filter);
  }

  public getAPlatformAdmin(id: any) {
    return this.userRepository.getAPlatformAdmin(id);
  }

  public deletePlatformAdmin(id: any) {
    return this.userRepository.deletePlatformAdmin(id);
  }

  public updatePlatformAdmin(id: any, values: any) {
    return this.userRepository.updatePlatformAdmin(id, values);
  }

  public verifyEmail(value: any) {
    return this.userRepository.verifyEmail(value);
  }

  public verifyNumber(value: any) {
    return this.userRepository.verifyNumber(value);
  }

  public verifyUsername(value: any) {
    return this.userRepository.verifyUsername(value);
  }

  public resetPassword(value: any) {
    return this.userRepository.resetPassword(value);
  }

  public sendCode(value: any) {
    return this.userRepository.sendCode(value);
  }

  public createOtp(value: any) {
    return this.userRepository.createOtp(value);
  }

  public logout(id: any, values: any) {
    return this.userRepository.logout(id, values);
  }

  public loginWithPassword(value: any) {
    return this.userRepository.loginWithPassword(value);
  }

  public getRefreshToken() {
    return this.userRepository.getRefreshToken();
  }

  // User Profile
  public getAdministrativeDivision() {
    return this.userRepository.getAdministrativeDivision();
  }

  public updateUserProfile(values: any) {
    return this.userRepository.updateUserProfile(values);
  }

  public additonalInfoVehicleOwner(values: any, id: number) {
    return this.userRepository.additonalInfoVehicleOwner(values, id);
  }

  public updatePassword(value: any) {
    return this.userRepository.updatePassword(value);
  }

  public getUserProfile() {
    return this.userRepository.getUserProfile();
  }

  public getShipper() {
    return this.userRepository.getShipper();
  }

  //  Users
  public getAllVechileOwner() {
    return this.userRepository.getAllVechileOwner();
  }

  public getAllNewVechileOwner(page: number, input: string, filter: string, report: string, isLoggedIn?: boolean, limit?: number) {
    return this.userRepository.getAllNewVechileOwner(page, input, filter, report, isLoggedIn, limit);
  }

  public getNoOfVehicles() {
    return this.userRepository.getNoOfVehicles();
  }

  public createVechileOwner(values: any) {
    return this.userRepository.createVechileOwner(values);
  }

  public getAUser(id: any) {
    return this.userRepository.getAUser(id);
  }

  public getVehiclesOfVehicleOwner(contactNumber: number, page: number) {
    return this.userRepository.getVehiclesOfVehicleOwner(contactNumber, page);
  }

  public getPointsOfVehicleOwner(userId: number, page: number) {
    return this.userRepository.getPointsOfVehicleOwner(userId, page);
  }

  public deleteVechileOwner(id: any) {
    return this.userRepository.deleteVechileOwner(id);
  }

  public rejectDeletionRequest(id: any, values: any) {
    return this.userRepository.rejectDeletionRequest(id, values);
  }

  public updateContractOwner(id: any, values: any) {
    return this.userRepository.updateContractOwner(id, values);
  }

  public createDriver(values: any) {
    return this.userRepository.createDriver(values);
  }

  public getAllDriver(page: number, input: string, filter: string, report: string, limit: any) {
    return this.userRepository.getAllDriver(page, input, filter, report, limit);
  }

  public getADriver(id: any) {
    return this.userRepository.getADriver(id);
  }

  public deleteDriver(id: any) {
    return this.userRepository.deleteDriver(id);
  }

  public updateDriver(id: any, values: any) {
    return this.userRepository.updateDriver(id, values);
  }

  public createShipper(values: any) {
    return this.userRepository.createShipper(values);
  }

  public getAllShipper(page: number, input: string, filter: string, accountStatus: string, report?: string) {
    return this.userRepository.getAllShipper(page, input, filter, accountStatus, report);
  }

  public getAShipper(id: any) {
    return this.userRepository.getAShipper(id);
  }

  public deleteShipper(id: any) {
    return this.userRepository.deleteShipper(id);
  }

  public updateShipper(id: any, values: any) {
    return this.userRepository.updateShipper(id, values);
  }

  public getAllDriverDevices() {
    return this.userRepository.getAllDriverDevices();
  }
  public getAllDeviceLocation(tripId: any) {
    return this.userRepository.getAllDeviceLocation(tripId);
  }
  public getAllRolesList(page: number, input: string, filter: string) {
    return this.userRepository.getAllRolesList(page, input, filter);
  }
  public getAllPermissionsList() {
    return this.userRepository.getAllPermissionsList();
  }
  public getRolePermission(id: any) {
    return this.userRepository.getRolePermission(id);
  }

  public assignPermissions(values: any) {
    return this.userRepository.assignPermissions(values);
  }

  //hash key
  public getHashKey() {
    return this.userRepository.getHashKey();
  }
  public generateNewHash() {
    return this.userRepository.generateNewHash();
  }

  //contract
  public getContract(type: string) {
    return this.userRepository.getContract(type);
  }

  public getContractById(id: number) {
    return this.userRepository.getContractById(id);
  }

  public generateContract(values: any) {
    return this.userRepository.generateContract(values);
  }

  //digital contract key
  public getDigitalContract() {
    return this.userRepository.getDigitalContract();
  }
  public generateDigitalContract(values: any) {
    return this.userRepository.generateDigitalContract(values);
  }
  public assignDriver(values: any) {
    return this.userRepository.assignDriver(values);
  }

  public getDashboard(role: "ROLE_VEHICLE_OWNER" | "ROLE_PLATFORM" | "ROLE_SHIPPER" | "ROLE_STAFF" | "ROLE_OTHER") {
    return this.userRepository.getDashboard(role);
  }

  public getAllDistanceBasedFee() {
    return this.userRepository.getAllDistanceBasedFee();
  }

  public addDistanceBasedFee(values: any) {
    return this.userRepository.addDistanceBasedFee(values);
  }

  public editDistanceBasedFee(values: any) {
    return this.userRepository.editDistanceBasedFee(values);
  }

  public deleteAllDistanceBasedFee() {
    return this.userRepository.deleteAllDistanceBasedFee();
  }

  public switchDistanceBasedFee(values: any) {
    return this.userRepository.switchDistanceBasedFee(values);
  }

  public getPercentageBasedFee() {
    return this.userRepository.getPercentageBasedFee();
  }

  public addPercentageBasedFee(values: any) {
    return this.userRepository.addPercentageBasedFee(values);
  }
  public switchPercentageBasedFee(values: any) {
    return this.userRepository.switchPercentageBasedFee(values);
  }

  public getIncrementalBasedFee() {
    return this.userRepository.getIncrementalBasedFee();
  }

  public addIncrementalBasedFee(values: any) {
    return this.userRepository.addIncrementalBasedFee(values);
  }

  public switchIncrementalBasedFee(values: any) {
    return this.userRepository.switchIncrementalBasedFee(values);
  }

  public getVehicleTypeBasedRule() {
    return this.userRepository.getVehicleTypeBasedRule();
  }
  public updateVehicleTypeBasedRule(value: VehicleTypeBasedInterface) {
    return this.userRepository.updateVehicleTypeBasedRule(value);
  }

  public deleteVehicleTypeRule(id: number) {
    return this.userRepository.deleteVehicleTypeRule(id);
  }

  public getSpeedData() {
    return this.userRepository.getSpeedData();
  }

  public addMaxSpeed(values: any) {
    return this.userRepository.addMaxSpeed(values);
  }

  //post roles
  public addNewRoles(values: any) {
    return this.userRepository.addNewRoles(values);
  }

  //delete role
  public deleteRole(id: number) {
    return this.userRepository.deleteRole(id);
  }

  //shipment report
  public getShipmentTrackingReport(orderNumber: any) {
    return this.userRepository.getShipmentTrackingReport(orderNumber);
  }

  public getShipmentCalendarReport(date: string) {
    return this.userRepository.getShipmentCalendarReport(date);
  }

  public getShipmentDispatchReport(page: number, input: string, filter: string) {
    return this.userRepository.getShipmentDispatchReport(page, input, filter);
  }

  public getSkippedAdditionalInfo = () => {
    return this.userRepository.getSkippedAdditionalInfo();
  };
  public setEstimatedPriceRule(values: any) {
    return this.userRepository.setEstimatedPriceRule(values);
  }

  public getEstimatedPriceRule() {
    return this.userRepository.getEstimatedPriceRule();
  }

  public updateEstimatedPriceRule() {
    return this.userRepository.updateEstimatedPriceRule();
  }

  public getAllVechileOwnerV2() {
    return this.userRepository.getAllVechileOwnerV2();
  }

  public getAllNewVehicleOwnerData(page: number, input: string, filter: string, report: string) {
    return this.userRepository.getAllNewVehicleOwnerData(page, input, filter, report);
  }

  public getOrderMatchingCriteria() {
    return this.userRepository.getOrderMatchingCriteria();
  }

  public updateOrderMatchingCriteria(criteriaId: number, values: any) {
    return this.userRepository.updateOrderMatchingCriteria(criteriaId, values);
  }

  public getAllContentThunk(page: number, input: string, filter: string) {
    return this.userRepository.getAllContents(page, input, filter);
  }

  public getAContent(id: any) {
    return this.userRepository.getAContent(id);
  }

  public createContent(values: any) {
    return this.userRepository.createContent(values);
  }

  public updateContent(id: number, values: any) {
    return this.userRepository.updateContent(id, values);
  }

  public deleteContent(id: number) {
    return this.userRepository.deleteContent(id);
  }

  public getSubscriptionPlan() {
    return this.userRepository.getSubscriptionPlan();
  }

  public getAllFeatures() {
    return this.userRepository.getAllFeatures();
  }

  public updatePlanActiveStatus(id: any, values: any) {
    return this.userRepository.updatePlanActiveStatus(id, values);
  }

  public updatePlanVATPrice(id: any, values: any) {
    return this.userRepository.updatePlanVATPrice(id, values);
  }

  public getSubscriptionPlanDetails(id: any) {
    return this.userRepository.getSubscriptionPlanDetails(id);
  }

  public updateGracePeriod(id: any, values: any) {
    return this.userRepository.updateGracePeriod(id, values);
  }

  public getPlanPrice() {
    return this.userRepository.getPlanPrice();
  }

  public initiateSubscriptionPayment(values: any) {
    return this.userRepository.initiateSubscriptionPayment(values);
  }

  public updateSubscriptionPayment(vehicleId: any, values: any) {
    return this.userRepository.updateSubscriptionPayment(vehicleId, values);
  }

  public updateVechileOwner(id: any, values: any) {
    return this.userRepository.updateVechileOwner(id, values);
  }

  public getCoolingPeriods() {
    return this.userRepository.getCoolingPeriods();
  }

  public updateCoolingPeriod(coolingPeriodId: number, value: number) {
    return this.userRepository.updateCoolingPeriod(coolingPeriodId, value);
  }

  public unlockUser(userId: number) {
    return this.userRepository.unlockUser(userId);
  }

  public getTaxRate() {
    return this.userRepository.getTaxRate();
  }

  public updateTaxRate(values: { rate: number; taxable: boolean }) {
    return this.userRepository.updateTaxRate(values);
  }

  public getPromotions(page: number, input?: string, filter?: string) {
    return this.userRepository.getPromotions(page, input, filter);
  }

  public updatePromotionStatus(promotionId: number, data: any) {
    return this.userRepository.updatePromotionStatus(promotionId, data);
  }

  public sendPromotionAlert(promotionId: number, alertTypes: string[]) {
    return this.userRepository.sendPromotionAlert(promotionId, alertTypes);
  }

  public createPromotion(values: any) {
    return this.userRepository.createPromotion(values);
  }

  public updatePromotion(promotionId: number, values: any) {
    return this.userRepository.updatePromotion(promotionId, values);
  }

  public getPromotion(promotionId: number) {
    return this.userRepository.getPromotion(promotionId);
  }
  public updateOwnProfile(values: any) {
    return this.userRepository.updateOwnProfile(values);
  }
  public getAwaitingAccountApproval(page: number, input: string, filter: string) {
    return this.userRepository.getAwaitingAccountApproval(page, input, filter);
  }

  public updateAccountApprovalStatus(userId: number, status: "approved" | "rejected" | string) {
    return this.userRepository.updateAccountApprovalStatus(userId, status);
  }

  public updateUserPoint(userId: number, point: number, paymentMethod: string) {
    return this.userRepository.updateUserPoint(userId, point, paymentMethod);
  }

  public getPointRefundDetail() {
    return this.userRepository.getPointRefundDetail();
  }

  public getPointRefundRequests(page: number, input: string, filter: string) {
    return this.userRepository.getPointRefundRequests(page, input, filter);
  }

  public pointRefundRequestAction(id: number, status: string, reason?: string) {
    return this.userRepository.pointRefundRequestAction(id, status, reason);
  }

  public getPointTransactionLogs(page: number, input: string, filter: string, limit?: number) {
    return this.userRepository.getPointTransactionLogs(page, input, filter, limit);
  }

  public pointRefundRequestThunk(amount: number) {
    return this.userRepository.pointRefundRequestThunk(amount);
  }

  public updateShipperTripAccess(userId: number, tripAccess: boolean) {
    return this.userRepository.updateShipperTripAccess(userId, tripAccess);
  }

  public getPaymentCommission(page: number, search: string) {
    return this.userRepository.getPaymentCommission(page, search);
  }

  public updatePaymentCommissionStatus(paymentPartnerId: number, status: boolean) {
    return this.userRepository.updatePaymentCommissionStatus(paymentPartnerId, status);
  }

  public updatePaymentCommission(paymentPartnerId: number, values: any) {
    return this.userRepository.updatePaymentCommission(paymentPartnerId, values);
  }

  public getContractHistory(userId: number, page: number, limit: number) {
    return this.userRepository.getContractHistory(userId, page, limit);
  }

  public getDeleteRequestedVehicleOwner(page: number, search: string, filter: string) {
    return this.userRepository.getDeleteRequestedVehicleOwner(page, search, filter);
  }

  public getDeleteRequestedDriver(page: number, search: string, filter: string) {
    return this.userRepository.getDeleteRequestedDriver(page, search, filter);
  }

  public getServerLogDataThunk(page: number, limit: number, search: string, filter: string) {
    return this.userRepository.getServerLogDataThunk(page, limit, search, filter);
  }
}
